import Vue from 'vue'
import vuex from 'vuex'

Vue.use(vuex);

import app from './modules/app'
import user from './modules/user'
import menu from './modules/menu'

const store = new vuex.Store({
    modules: {
        app: app,
        user: user,
        menu: menu,
    },
    getters: {
        company: state=>state.app.company,
        project: state=>state.app.project,
        appName: state=>state.app.appName,
    },
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js